export default __webpack_public_path__ + "static/Download_App-7e5e57b2c7d9a24afd4021fb64af1c45.png";